import { ReportsFilter } from '../models/ReportsFilter';

export function validateIfWeGotFiltersApplyInProgressPage(filters: ReportsFilter) {
  if (typeof filters?.roadmaps?.id === 'string' && filters?.roadmaps?.id?.trim() !== '' && filters?.classes?.length) {
    return true;
  }
  return false;
}
